import "../../App.css";
import "./WithdrawRequest.css";
import {
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import {
    useSearchParams,
} from "react-router-dom";
import {
    Input,
    Table,
    Tooltip,
    message,
} from "antd";
import axios from 'axios';
import Appconfig from '../../config/config'
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { WebSocketContext } from '../../context/websocket';
import { CopyOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const VALID_WITHDRAW_FILTERS = [
    "pending",
    "approved",
    "rejected",
    "all",
];

const normalizeWithdrawStatus = (status) => {
    return String(status || "")
        .trim()
        .toLowerCase();
};

const isPendingWithdrawStatus = (status) => {
    return [
        "request",
        "process",
        "pending",
    ].includes(
        normalizeWithdrawStatus(status)
    );
};

const isApprovedWithdrawStatus = (status) => {
    return [
        "confirm",
        "confirmed",
        "approved",
    ].includes(
        normalizeWithdrawStatus(status)
    );
};

const isRejectedWithdrawStatus = (status) => {
    return [
        "reject",
        "rejected",
        "cancel",
        "cancelled",
        "canceled",
    ].includes(
        normalizeWithdrawStatus(status)
    );
};

const isWithdrawWithinRange = (
    record,
    fromDate,
    toDate
) => {
    if (!fromDate && !toDate) {
        return true;
    }

    const recordDate = new Date(
        record?.createdAt ||
        record?.created_at ||
        0
    );

    if (Number.isNaN(recordDate.getTime())) {
        return false;
    }

    const parsedFromDate = fromDate
        ? new Date(fromDate)
        : null;

    const parsedToDate = toDate
        ? new Date(toDate)
        : null;

    if (
        parsedFromDate &&
        !Number.isNaN(parsedFromDate.getTime()) &&
        recordDate < parsedFromDate
    ) {
        return false;
    }

    if (
        parsedToDate &&
        !Number.isNaN(parsedToDate.getTime()) &&
        recordDate > parsedToDate
    ) {
        return false;
    }

    return true;
};

const getWithdrawStatusClass = (status) => {
    const normalizedStatus = String(
        status || ""
    )
        .trim()
        .toLowerCase();

    if (
        normalizedStatus === "confirm" ||
        normalizedStatus === "confirmed" ||
        normalizedStatus === "approved"
    ) {
        return "approved";
    }

    if (
        normalizedStatus === "reject" ||
        normalizedStatus === "rejected" ||
        normalizedStatus === "cancel" ||
        normalizedStatus === "cancelled" ||
        normalizedStatus === "canceled"
    ) {
        return "rejected";
    }

    /*
     * Request, Process aur unknown active
     * status pending style mein show honge.
     */
    return "pending";
};

function WithdrawRequest() {

    const [searchParams] = useSearchParams();

    const pendingSectionRef = useRef(null);
    const historySectionRef = useRef(null);

    const requestedFilter = String(
        searchParams.get("status") || "all"
    ).toLowerCase();

    const activeFilter =
        VALID_WITHDRAW_FILTERS.includes(
            requestedFilter
        )
            ? requestedFilter
            : "all";

    const dashboardFromDate =
        searchParams.get("from_date");

    const dashboardToDate =
        searchParams.get("to_date");

    const websocket = useContext(WebSocketContext);

    const userInfo = JSON.parse(localStorage.getItem('userdata'))
    const [openBanner, setOpenBanner] = useState(false)
    const [button, setButton] = useState(false)
    const [fileList, setFileList] = useState([]);
    const [banners, setBanners] = useState([])
    const [id, setId] = useState('')
    const [paymentType, setPaymentType] = useState(""); // State to track selected payment type
    const [formData, setFormData] = useState({
        user_id: userInfo?._id,
        site_code: Appconfig.sitecodes,
        accountNo: "",
        accountHolder: "",
        ifscCode: "",
        bankName: "",
        upiId: "",
        holderName: ""
    });
    const [remark, setRemark] = useState('');


    const [withdrawRequest, setWithdrawRequest] = useState([]);
    const [withdrawHistory, setWithdrawHistory] = useState([]);

    const [
        withdrawRequestLoading,
        setWithdrawRequestLoading,
    ] = useState(false);

    const [
        withdrawHistoryLoading,
        setWithdrawHistoryLoading,
    ] = useState(false);

    const filteredWithdrawRequests = useMemo(() => {
        if (
            activeFilter !== "pending" &&
            activeFilter !== "all"
        ) {
            return [];
        }

        /*
         * Pending API already pending/process withdrawal
         * requests return karti hai.
         */
        return withdrawRequest;
    }, [
        withdrawRequest,
        activeFilter,
    ]);

    const filteredWithdrawHistory = useMemo(() => {
        /*
         * Pending aur All par complete history.
         */
        if (
            activeFilter === "pending" ||
            activeFilter === "all"
        ) {
            return withdrawHistory;
        }

        if (activeFilter === "approved") {
            return withdrawHistory.filter(
                (record) =>
                    isApprovedWithdrawStatus(
                        record?.status
                    )
            );
        }

        if (activeFilter === "rejected") {
            return withdrawHistory.filter(
                (record) =>
                    isRejectedWithdrawStatus(
                        record?.status
                    )
            );
        }

        return withdrawHistory;
    }, [
        withdrawHistory,
        activeFilter,
    ]);

    const showPendingSection =
        activeFilter === "pending" ||
        activeFilter === "all";

    /*
     * Transaction History always visible.
     */
    const showHistorySection = true;

    const withdrawalHistoryHeading =
        "Transaction History";

    const withdrawalHistoryDescription =
        activeFilter === "approved"
            ? "Showing approved withdrawal transactions"
            : activeFilter === "rejected"
                ? "Showing rejected withdrawal transactions"
                : activeFilter === "pending"
                    ? "Complete withdrawal transaction history"
                    : "Completed and rejected withdrawal requests";

    function confirmWithdrawRequest(record, status) {
        setButton(true)
        var data = JSON.stringify({
            record: record,
            status: status,
            master_details: userInfo,
            remark: remark
        });
        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}withdraw/confirmWithdraw`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.result) {
                    NotificationManager.success(response.data.resultMessage, '', 3000);
                    getWithdrawRequest();
                    getWithdrawHistory();

                    if (websocket && websocket.readyState) {
                        console.log("Sending user balance via WebSocket...");
                        websocket.send(JSON.stringify({
                            action: "USER_BLOCK_UPDATE",
                            data: {
                                user_id: userInfo?._id,
                            }
                        }));
                    }


                } else {
                    NotificationManager.error(response.data.resultMessage, '', 3000);
                }
                setButton(false)
            })
            .catch(function (error) {
                console.error(
                    "Withdrawal update failed:",
                    error
                );

                NotificationManager.error(
                    error?.response?.data?.resultMessage ||
                    "Unable to update withdrawal request.",
                    "",
                    3000
                );

                setButton(false);
            });
    }

    const columns = [
        {
            title: 'User Name',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.user_name}
                </span>
            ),
        },

        {
            title: 'Amount',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.amount}
                </span>
            ),
        },

        // {
        //     title: 'Total Balance',
        //     sorter: true,
        //     render: (_, record) => (
        //         <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
        //         </span>
        //     ),
        // },
        // {
        //     title: 'Available Balance',
        //     sorter: true,
        //     render: (_, record) => (
        //         <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
        //         </span>
        //     ),
        // },
        {
            title: 'Type',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.type}
                </span>
            ),
        },
        {
            title: 'Bank Name',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.bank_name ? record?.bank_name : 'N/A'}
                </span>
            ),
        },
        // {
        //     title: 'Account/UPI',
        //     sorter: true,
        //     render: (_, record) => (
        //         <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
        //             {record?.upi_id ? record?.upi_id : record?.account_no}
        //         </span>
        //     ),
        // },
        {
            title: 'Account No',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.account_no || 'N/A'}
                </span>
            ),
        },
        {
            title: 'UPI ID',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.upi_id || 'N/A'}
                </span>
            ),
        },
        {
            title: 'IFSC Code',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.ifsc_code ? record?.ifsc_code : 'N/A'}
                </span>
            ),
        },
        {
            title: 'Holder Name',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {/* {record?.holder_name ? record?.holder_name : 'N/A'} */}
                    {record?.account_holder_name ? record?.account_holder_name : 'N/A'}
                    {/* {record?.account_holder_name || 'N/A'} */}
                </span>
            ),
        },
        {
            title: 'Remark',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    <Input
                        className="withdraw-remark-input"
                        placeholder="Enter remark"
                        onChange={(event) =>
                            setRemark(event.target.value)
                        }
                    />
                </span>
            ),
        },
        {
            title: 'Request Date',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {(new Date(record?.createdAt)).toLocaleString()}
                </span>
            ),
        },
        {
            title: "Status",
            key: "status",
            width: 105,
            sorter: (first, second) =>
                String(
                    first?.status || ""
                ).localeCompare(
                    String(
                        second?.status || ""
                    )
                ),
            render: (_, record) => (
                <span
                    className={`withdraw-status ${getWithdrawStatusClass(
                        record?.status
                    )}`}
                >
                    {record?.status || "-"}
                </span>
            ),
        },
        {
            title: "Action",
            key: "action",
            width: 190,
            fixed: "right",
            render: (_, record) => {
                const nextStatus =
                    record?.status === "Process"
                        ? "Confirm"
                        : "Process";

                return (
                    <div className="withdraw-actions">
                        <button
                            type="button"
                            disabled={button}
                            className="withdraw-confirm-button"
                            onClick={() =>
                                confirmWithdrawRequest(
                                    record,
                                    nextStatus
                                )
                            }
                        >
                            <CheckCircleOutlined />

                            <span>
                                {nextStatus}
                            </span>
                        </button>

                        <button
                            type="button"
                            disabled={button}
                            className="withdraw-reject-button"
                            onClick={() =>
                                confirmWithdrawRequest(
                                    record,
                                    "Reject"
                                )
                            }
                        >
                            <CloseCircleOutlined />

                            <span>Reject</span>
                        </button>
                    </div>
                );
            },
        },

        {
            title: "Copy",
            key: "copy",
            width: 70,
            align: "center",
            fixed: "right",
            render: (_, record) => (
                <Tooltip title="Copy payment details">
                    <button
                        type="button"
                        className="withdraw-copy-button"
                        onClick={() =>
                            handleCopy(record)
                        }
                        aria-label="Copy withdrawal details"
                    >
                        <CopyOutlined />
                    </button>
                </Tooltip>
            ),
        },

    ];

    // const handleCopy = (record) => {
    //     const copyText = JSON.stringify(record, null, 2); // formatted JSON
    //     navigator.clipboard.writeText(copyText)
    //         .then(() => {
    //         message.success('Row data copied to clipboard!');
    //         })
    //         .catch(() => {
    //         message.error('Failed to copy!');
    //         });
    // };

    const handleCopy = (record) => {
        const visibleData = `
        User Name: ${record?.user_name}
        Amount: ${record?.amount}
        Type: ${record?.type}
        Bank Name: ${record?.bank_name || 'N/A'}
        Account/UPI: ${record?.upi_id || record?.account_no || 'N/A'}
        IFSC Code: ${record?.ifsc_code || 'N/A'}
        Holder Name: ${record?.account_holder_name || 'N/A'}
        Request Date: ${new Date(record?.createdAt).toLocaleString()}
        Status: ${record?.status}
        `.trim();

        navigator.clipboard.writeText(visibleData)
            .then(() => {
                message.success('Data copied!');
            })
            .catch(() => {
                message.error('Copy failed!');
            });
    };



    const historyColumns = [
        {
            title: 'User Name',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.user_name}
                </span>
            ),
        },
        // {
        //     title: 'User Id',
        //     sorter: true,
        //     render: (_, record) => (
        //         <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
        //             {record?.user_id}
        //         </span>
        //     ),
        // },
        {
            title: 'Type',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.type}
                </span>
            ),
        },
        ...(withdrawHistory.some((record) => record.bank_name) // Check if any record has a bank name
            ? [
                {
                    title: 'Bank Name',
                    sorter: true,
                    render: (_, record) => (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                            {record?.bank_name || 'N/A'}
                        </span>
                    ),
                },
            ]
            : []), // If no record has a bank name, exclude this column
        ...(withdrawHistory.some((record) => record.account_no) // Check if any record has a bank name
            ? [
                {
                    title: 'Account Num',
                    sorter: true,
                    render: (_, record) => (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                            {record?.account_no || 'N/A'}
                        </span>
                    ),
                },
            ]
            : []), // If no record has a bank name, exclude this column
        // ...(withdrawHistory.some((record) => record.account_holder_name) // Check if any record has a bank name
        //     ? [
        //         {
        //             title: 'Account Holder Name',
        //             sorter: true,
        //             render: (_, record) => (
        //                 <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
        //                     {record?.account_holder_name || 'N/A'}
        //                 </span>
        //             ),
        //         },
        //     ]
        //     : []), // If no record has a bank name, exclude this column
        ...(withdrawHistory.some((record) => record.ifsc_code) // Check if any record has a bank name
            ? [
                {
                    title: 'IFSC Code',
                    sorter: true,
                    render: (_, record) => (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                            {record?.ifsc_code || 'N/A'}
                        </span>
                    ),
                },
            ]
            : []), // If no record has a bank name, exclude this column
        ...(withdrawHistory.some((record) => record.upi_id) // Check if any record has a bank name
            ? [
                {
                    title: 'UPI Id',
                    sorter: true,
                    render: (_, record) => (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                            {record?.upi_id || 'N/A'}
                        </span>
                    ),
                },
            ]
            : []), // If no record has a bank name, exclude this column
        ...(withdrawHistory.some((record) => record.holder_name) // Check if any record has a bank name
            ? [
                {
                    title: 'Holder Name',
                    sorter: true,
                    render: (_, record) => (
                        <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                            {/* {record?.holder_name || 'N/A'} */}
                            {record?.account_holder_name || 'N/A'}
                        </span>
                    ),
                },
            ]
            : []), // If no record has a bank name, exclude this column
        {
            title: 'Remarks',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.remark}
                </span>
            ),
        },
        {
            title: 'Amount',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {record?.amount}
                </span>
            ),
        },
        {
            title: 'Request Date',
            sorter: true,
            render: (_, record) => (
                <span className='font-extrabold text-[#212529] text-[0.813rem] ml-[5px]'>
                    {(new Date(record?.createdAt)).toLocaleString()}
                </span>
            ),
        },
        {
            title: "Status",
            key: "status",
            width: 105,
            sorter: (first, second) =>
                String(
                    first?.status || ""
                ).localeCompare(
                    String(
                        second?.status || ""
                    )
                ),
            render: (_, record) => (
                <span
                    className={`withdraw-status ${getWithdrawStatusClass(
                        record?.status
                    )}`}
                >
                    {record?.status || "-"}
                </span>
            ),
        },
    ];

    const getWithdrawRequest = async () => {
        if (!userInfo?._id) {
            setWithdrawRequest([]);
            return;
        }

        setWithdrawRequestLoading(true);

        try {
            const response = await axios.post(
                `${Appconfig.apiUrl}withdraw/getWithdrawRequest`,
                {
                    site_code: Appconfig.sitecodes,
                    user_id: userInfo._id,
                },
                {
                    headers: {
                        "Content-Type":
                            "application/json",
                    },
                }
            );

            if (response?.data?.result) {
                setWithdrawRequest(
                    Array.isArray(
                        response.data.resultData
                    )
                        ? response.data.resultData
                        : []
                );

                return;
            }

            setWithdrawRequest([]);

            NotificationManager.error(
                response?.data?.resultMessage ||
                "Unable to load withdrawal requests.",
                "",
                3000
            );
        } catch (error) {
            console.error(
                "Withdrawal request error:",
                error
            );

            setWithdrawRequest([]);

            NotificationManager.error(
                error?.response?.data?.resultMessage ||
                "Unable to load withdrawal requests.",
                "",
                3000
            );
        } finally {
            setWithdrawRequestLoading(false);
        }
    };

    const getWithdrawHistory = async () => {
        if (!userInfo?._id) {
            setWithdrawHistory([]);
            return;
        }

        setWithdrawHistoryLoading(true);

        try {
            const response = await axios.post(
                `${Appconfig.apiUrl}withdraw/getWithdrawHistory`,
                {
                    site_code: Appconfig.sitecodes,
                    master_id: userInfo._id,
                },
                {
                    headers: {
                        "Content-Type":
                            "application/json",
                    },
                }
            );

            if (response?.data?.result) {
                setWithdrawHistory(
                    Array.isArray(
                        response.data.resultData
                    )
                        ? response.data.resultData
                        : []
                );

                return;
            }

            setWithdrawHistory([]);

            NotificationManager.error(
                response?.data?.resultMessage ||
                "Unable to load withdrawal history.",
                "",
                3000
            );
        } catch (error) {
            console.error(
                "Withdrawal history error:",
                error
            );

            setWithdrawHistory([]);

            NotificationManager.error(
                error?.response?.data?.resultMessage ||
                "Unable to load withdrawal history.",
                "",
                3000
            );
        } finally {
            setWithdrawHistoryLoading(false);
        }
    };


    useEffect(() => {
        getWithdrawRequest();
        getWithdrawHistory();

        // Initial request only
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const scrollTimer = window.setTimeout(
            () => {
                if (activeFilter === "pending") {
                    pendingSectionRef.current
                        ?.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });

                    return;
                }

                if (
                    activeFilter === "approved" ||
                    activeFilter === "rejected"
                ) {
                    historySectionRef.current
                        ?.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                }
            },
            100
        );

        return () => {
            window.clearTimeout(scrollTimer);
        };
    }, [activeFilter]);


    return (
        <>
            <NotificationContainer />

            <main className="withdraw-page">
                {/* Premium overview header */}
                <section className="withdraw-overview">
                    <div className="withdraw-page-heading">
                        <div className="withdraw-heading-content">
                            <span
                                className="withdraw-heading-icon"
                                aria-hidden="true"
                            >
                                ↑
                            </span>

                            <div>
                                <h1>
                                    Withdrawal Management
                                </h1>

                                <p>
                                    Review pending requests
                                    and withdrawal history
                                </p>
                            </div>
                        </div>

                        <div className="withdraw-overview-counts">
                            <div className="withdraw-count pending">
                                <span>
                                    Pending Requests
                                </span>

                                <strong>
                                    {
                                        filteredWithdrawRequests.length
                                    }
                                </strong>
                            </div>

                            <div className="withdraw-count history">
                                <span>
                                    History Records
                                </span>

                                <strong>
                                    {
                                        filteredWithdrawHistory.length
                                    }
                                </strong>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pending withdrawal table */}
                {showPendingSection && (
                    <section
                        ref={pendingSectionRef}
                        className="withdraw-card"
                    >
                        <div className="withdraw-card-heading">
                            <div>
                                <h2>
                                    Pending Withdrawal Requests
                                </h2>

                                <p>
                                    Process, confirm or reject
                                    pending user withdrawals
                                </p>
                            </div>

                            <span className="withdraw-heading-count">
                                {
                                    filteredWithdrawRequests.length
                                }
                            </span>
                        </div>

                        <div className="withdraw-table-wrapper">
                            <Table
                                rowKey={(record) =>
                                    record?._id
                                }
                                columns={columns}
                                dataSource={
                                    filteredWithdrawRequests
                                }
                                className="withdraw-table"
                                loading={
                                    withdrawRequestLoading
                                }
                                pagination={false}
                                locale={{
                                    emptyText:
                                        "No pending withdrawal requests found.",
                                }}
                                scroll={{
                                    x: 1450,
                                }}
                            />
                        </div>
                    </section>
                )}

                {/* Transaction History always visible */}
                {showHistorySection && (
                    <section
                        ref={historySectionRef}
                        className="withdraw-card"
                    >
                        <div className="withdraw-card-heading">
                            <div>
                                <h2>
                                    {withdrawalHistoryHeading}
                                </h2>

                                <p>
                                    {
                                        withdrawalHistoryDescription
                                    }
                                </p>
                            </div>

                            <span className="withdraw-heading-count">
                                {
                                    filteredWithdrawHistory.length
                                }
                            </span>
                        </div>

                        <div className="withdraw-table-wrapper">
                            <Table
                                rowKey={(record) =>
                                    record?._id
                                }
                                columns={historyColumns}
                                dataSource={
                                    filteredWithdrawHistory
                                }
                                className="withdraw-table withdraw-history-table"
                                loading={
                                    withdrawHistoryLoading
                                }
                                pagination={{
                                    pageSize: 10,
                                    showSizeChanger: false,
                                    hideOnSinglePage: true,
                                }}
                                locale={{
                                    emptyText:
                                        activeFilter ===
                                            "approved"
                                            ? "No approved withdrawal transactions found."
                                            : activeFilter ===
                                                "rejected"
                                                ? "No rejected withdrawal transactions found."
                                                : "No withdrawal history found.",
                                }}
                                scroll={{
                                    x: 1250,
                                }}
                            />
                        </div>
                    </section>
                )}
            </main>
        </>
    );
}


export default WithdrawRequest;
